import React from 'react';
const SupportFormBody = ({ children }) => (
  <div className="support-form-body">{children}</div>
);

export default SupportFormBody;
